import React from 'react';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { useAppSelector } from 'src/hooks';
import { Title, Paper } from '../../components';
import { help } from '../../constants/mainViewList';
import { mainColor } from '../../constants';
import { version } from '../../../package.json';
import { styles } from './Assistance.styles';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';

function Assistance({ showHelpModal, classes }) {
    const sidebarCollapse = useAppSelector((state) => state.sidebar.sidebarCollapse);


    return (
        <div className='px-4 pb-4'>
            <Title title="Besoin d'aide" onClick={() => showHelpModal('')} />
            <div className={`col-12 ${sidebarCollapse ? 'col-lg-10' : ''} flex-row justify-content-center align-items-center px-0`}>
                <div className='col-md-12 p-0'>
                    <Paper>
                        <List>
                            {_.map(Object.values(help), (helpItem, index) => {
                                return (
                                    <Link
                                        key={index}
                                        style={{ color: 'transparent' }}
                                        to={{
                                            pathname: `${helpItem.url}`,
                                            state: { title: helpItem.text, subtitle: helpItem.description }
                                        }}
                                    >
                                        <ListItem button className={classes.gutters} disabled={index === 0}>
                                            <ListItemIcon>{helpItem.icon}</ListItemIcon>
                                            <ListItemText
                                                style={{ color: mainColor.colorBlack }}
                                                primary={helpItem.text}
                                                secondary={helpItem.description}
                                            />
                                            <ChevronRight style={{ color: mainColor.colorBlack }} />
                                        </ListItem>
                                        {index <= _.size(help) - 2 && <Divider variant='inset' component='li' />}
                                    </Link>
                                );
                            })}
                        </List>
                    </Paper>
                    <p className={classes.versionText}> Version: {version} </p>
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(withRouter(Assistance));